/* eslint-disable */
import Api from '@/repository'
import { Message } from 'element-ui'
import { errorResponseMessage } from '@/utils/createMessage'
import Vue from 'vue'

export const ADD_CANDIDATE = 'ADD_CANDIDATE'
export const SET_ALL_CANDIDATES = 'SET_ALL_CANDIDATES'
export const REMOVE_CANDIDATE = 'REMOVE_CANDIDATE'
export const ADD_CANDIDATE_FOR_TRIAL = 'ADD_CANDIDATE_FOR_TRIAL'
export const SET_ALL_TRIAL_CANDIDATES = 'SET_ALL_TRIAL_CANDIDATES'
export const EDIT_CANDIDATE = 'EDIT_CANDIDATE'
export const APPROVE_CANDIDATE = 'APPROVE_CANDIDATE'
export const TOGGLE_LOADING = 'TOGGLE_LOADING'
const state = {
  isLoading: true,
  candidates: [],
  trialCandidates: []
}

const mutations = {
  [TOGGLE_LOADING]: (state, status) => {
    state.isLoading = status
  },
  [SET_ALL_CANDIDATES]: (state, data) => {
    state.candidates = data
  },
  [ADD_CANDIDATE]: (state, data) => {
    state.candidates.push(data)
  },
  [REMOVE_CANDIDATE]: (state, id) => {
    state.candidates = state.candidates.filter((candidate) => candidate.driverId !== id)
    state.trialCandidates = state.trialCandidates.filter((candidate) => candidate.driverId !== id)
  },
  [ADD_CANDIDATE_FOR_TRIAL]: (state, data) => {
    state.candidates = state.candidates.filter((candidate) => candidate.driverId !== data.driverId)
    state.trialCandidates.push(data)
  },
  [SET_ALL_TRIAL_CANDIDATES]: (state, data) => {
    state.trialCandidates = data
  },
  [EDIT_CANDIDATE]: (state, data) => {
    const candidateIndex = state.candidates.findIndex(candidate => candidate.driverId === data.driverId)

    if (candidateIndex !== -1) {
      Vue.set(state.candidates, candidateIndex, data)
    }

    const trialCandidateIndex = state.trialCandidates.findIndex(candidate => candidate.driverId === data.driverId)

    if (trialCandidateIndex !== -1) {
      Vue.set(state.trialCandidates, trialCandidateIndex, data)
    }
  },
  [APPROVE_CANDIDATE]: (state, id) => {
    state.trialCandidates = state.trialCandidates.filter((candidate) => candidate.driverId !== id)
  }
}

const actions = {
  async setCandidate ({ commit }, data) {
    try {
      const response = await Api.parkManager.drivers.addNewCandidateDrivers({ candidate: data })

      commit('ADD_CANDIDATE', response.candidate)

      Message({
        message: 'Кандидат был успешно добавлен!',
        type: 'success',
        duration: 5 * 1000
      })

      return response
    } catch (err) {
      await errorResponseMessage(err.response.data)
      return Promise.reject(err)
    }
  },
  async getAllCandidates ({ commit }) {
    try {
      commit('TOGGLE_LOADING', true)
      const response = await Api.parkManager.drivers.getCandidateDrivers({
        offset: 0,
        limit: 991000,
        category: 'candidate'
      })

      commit('SET_ALL_CANDIDATES', response.drivers)
      commit('TOGGLE_LOADING', false)

      return response
    } catch (err) {
      await errorResponseMessage(err.response.data)
      return Promise.reject(err)
    }
  },
  async removeCandidateDrivers ({ commit }, id) {
    try {
      const response = await Api.parkManager.drivers.removeCandidateDrivers(id)

      commit('REMOVE_CANDIDATE', id)

      Message({
        message: 'Кандидат был успешно удален!',
        type: 'success',
        duration: 5 * 1000
      })

      return response
    } catch (err) {
      await errorResponseMessage(err.response.data)
      return Promise.reject(err)
    }
  },
  async addTrialCandidate ({ commit }, data) {
    try {
      const response = await Api.parkManager.drivers.addCandidateInTrial(data)

      commit('ADD_CANDIDATE_FOR_TRIAL', response.driver)

      Message({
        message: 'Кандидат был успешно добавлен на испытательный срок!',
        type: 'success',
        duration: 5 * 1000
      })

      return response
    } catch (err) {
      await errorResponseMessage(err.response.data)
      return Promise.reject(err)
    }
  },

  async getAllCandidatesTrial ({ commit }) {
    try {
      commit('TOGGLE_LOADING', true)

      const response = await Api.parkManager.drivers.getCandidateDrivers({
        offset: 0,
        limit: 991000,
        category: 'trial'
      })

      commit('SET_ALL_TRIAL_CANDIDATES', response.drivers)
      commit('TOGGLE_LOADING', false)

      return response
    } catch (err) {
      await errorResponseMessage(err.response.data)
      return Promise.reject(err)
    }
  },
  editCandidate ({ commit }, data) {
    commit('EDIT_CANDIDATE', data)
  },

  async approveCandidate ({ commit }, data) {
    try {
      const response = await Api.parkManager.drivers.approveCandidate(data.driverId, { taxiServiceId: data.taxiId })

      commit('APPROVE_CANDIDATE', data.driverId)

      Message({
        message: 'Кандидат был успешно добавлен в общий список!',
        type: 'success',
        duration: 5 * 1000
      })

      return response
    } catch (err) {
      await errorResponseMessage(err.response.data)
      return Promise.reject(err)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
